"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.scss");
const react_1 = __importStar(require("react"));
const WriterMisspellingForm_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterUpdateRequestSidebar/WriterMisspellingForm"));
const contexts_1 = require("@App/contexts");
const ConfirmationStep_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterUpdateRequestSidebar/ConfirmationStep"));
const SelectReasonStep_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterUpdateRequestSidebar/SelectReasonStep"));
const SongwriterUpdateRequestSidebar = (props) => {
    const { selectedWriterName, selectedWriterIpId, closeSidebar } = props;
    const { songwriterWriterSearchStore, popupStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [reason, setReason] = (0, react_1.useState)(null);
    const [step, setStep] = (0, react_1.useState)('selectReason');
    const onBack = () => {
        setStep('selectReason');
    };
    const formsByReason = {
        Misspelling: (react_1.default.createElement(WriterMisspellingForm_1.default, { onBack: onBack, onSubmit: (formData) => submitTicket(formData), selectedWriterName: selectedWriterName })),
    };
    const submitTicket = (formData) => {
        if (reason && reason.value) {
            preloaderStore.openTransparentPreloader(true);
            songwriterWriterSearchStore
                .submitWriterUpdateRequest(selectedWriterIpId, selectedWriterName, reason.value, formData)
                .then(() => setStep('confirmation'))
                .catch((error) => popupStore.setAlertData(error.message, true))
                .finally(() => preloaderStore.openTransparentPreloader(false));
        }
    };
    const renderFormByReason = () => {
        if (!reason) {
            return null;
        }
        return formsByReason[reason.value] || null;
    };
    return (react_1.default.createElement("div", { className: "songwriter-request-update-wrapper" }, (() => {
        switch (step) {
            case 'selectReason':
                return (react_1.default.createElement(SelectReasonStep_1.default, { setStep: (newStep) => setStep(newStep), reason: reason, setReason: (newReason) => setReason(newReason) }));
            case 'form':
                return renderFormByReason();
            case 'confirmation':
                return react_1.default.createElement(ConfirmationStep_1.default, { closeSidebar: closeSidebar });
        }
    })()));
};
exports.default = SongwriterUpdateRequestSidebar;
